import { useTranslation } from 'react-i18next'
import { HELP_FAQ_ITEMS } from './faq-data'
import { Accordion, AccordionItem } from '../../components/Accordion'
import { FileText, Mail, Clock, MessageCircle } from 'lucide-react'

export function HelpPage() {
  const { t } = useTranslation('help')

  return (
    <div data-testid="help-page" style={{ maxWidth: 860, margin: '0 auto', padding: '0 16px' }}>
      <div className="section-header">
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 700, margin: '0 0 8px 0' }}>{t('title')}</h1>
          <p className="muted" style={{ margin: 0 }}>{t('subtitle')}</p>
        </div>
      </div>

      <div style={{ display: 'grid', gap: 24, gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', marginBottom: 48 }}>
        <a
          href="mailto:support@heliumtracker.io"
          className="card card-pad"
          style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
        >
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--c-primary-muted, rgba(99, 102, 241, 0.1))', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16, color: 'var(--c-primary, #6366f1)' }}>
            <Mail size={24} />
          </div>
          <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8, color: 'var(--text)' }}>{t('emailSupport.title')}</div>
          <p className="muted" style={{ fontSize: 14, margin: '0 0 16px 0' }}>
            {t('emailSupport.description')}
          </p>
          <div style={{ color: 'var(--c-primary, #6366f1)', fontWeight: 500 }}>support@heliumtracker.io</div>
        </a>

        <a
          href="https://docs.heliumtracker.io"
          target="_blank"
          rel="noopener noreferrer"
          className="card card-pad"
          style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
        >
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--c-primary-muted, rgba(99, 102, 241, 0.1))', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16, color: 'var(--c-primary, #6366f1)' }}>
            <FileText size={24} />
          </div>
          <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8, color: 'var(--text)' }}>{t('docs.title')}</div>
          <p className="muted" style={{ fontSize: 14, margin: '0 0 16px 0' }}>
            {t('docs.description')}
          </p>
          <div style={{ color: 'var(--c-primary, #6366f1)', fontWeight: 500 }}>{t('docs.link')}</div>
        </a>
      </div>

      <div style={{ marginBottom: 24 }}>
        <a
          href="/support"
          className="card card-pad"
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 16 }}
        >
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--c-primary-muted, rgba(99, 102, 241, 0.1))', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: 'var(--c-primary, #6366f1)' }}>
            <MessageCircle size={24} />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4, color: 'var(--text)' }}>{t('contactForm.title')}</div>
            <p className="muted" style={{ fontSize: 14, margin: 0 }}>
              {t('contactForm.description')}
            </p>
          </div>
          <div style={{ marginLeft: 'auto', color: 'var(--c-primary, #6366f1)', fontWeight: 500 }}>→</div>
        </a>
      </div>

      <div className="card card-pad" style={{ marginBottom: 48 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
           <div style={{ color: 'var(--c-primary, #6366f1)', flexShrink: 0 }}>
             <Clock size={24} />
           </div>
           <div>
             <h3 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 4px 0', color: 'var(--text)' }}>{t('sla.title')}</h3>
             <p className="muted" style={{ margin: 0, fontSize: 14, lineHeight: 1.5 }}>
               {t('sla.description')}
             </p>
           </div>
        </div>
      </div>

      <section data-testid="help-faq-section" style={{ paddingBottom: 48 }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24, color: 'var(--text)' }}>{t('faq.title')}</h2>

        <div className="card" style={{ padding: '0 16px' }}>
          <Accordion>
            {HELP_FAQ_ITEMS.map((item, index) => (
              <AccordionItem
                key={item.questionKey}
                id={`help-faq-${index}`}
                title={t(item.questionKey)}
              >
                <p style={{ margin: 0 }}>{t(item.answerKey)}</p>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  )
}
